<nav class="navbar-top">
	<p>Svelte Pokédex</p>
</nav>

<style>
	.navbar-top {
		z-index: 2;
		height: 70px;
		width: 100%;
		position: fixed;
		top: 0;
		background-color: #3d087b;
	}

	.navbar-top p {
		text-align: center;
		font-size: 35px;
		line-height: 70px;
		color: #ffe459;
	}
</style>
